import React from 'react';
import parse from 'html-react-parser';
import { useHistory } from 'react-router';
import { Icon } from '../../../../components';
import { Container } from './styles';
import routes from '../../../../components/Routes/routingMap';

interface ContentModalOneButtonProps {
  img?: any;
  title: string;
  subtitle?: any;
  subtitle0?: any;
  showInfo: boolean;
  info?: any;
  showLink?: boolean;
  textButton: string;
  style?: React.CSSProperties;
  center?: boolean;
  onClickButton: () => void;
}
const ContentModalOneButton = (props: ContentModalOneButtonProps) => {
  const {
    img,
    title,
    subtitle,
    subtitle0,
    showInfo,
    info,
    textButton,
    style,
    center,
    onClickButton,
    showLink
  } = props;

  const styleUpdated: any = { ...style, textAlign: center ? 'center' : 'auto' };

  const history = useHistory();
  return (
    <Container>
      {img && <img src={img} alt="" />}
      <span className="contentTitle" style={styleUpdated}>
        {parse(title)}
      </span>
      {subtitle && showLink && (
        <div style={{ display: 'flex', gap: '2px', width: '100%' }}>
          {' '}
          <p className="contentSubtitle">
            {subtitle}{' '}
            <button
              className="goToWhatsapp"
              type="button"
              onClick={() => {
                history.push(
                  routes.student.procedures.categories.tickets.register
                );
              }}
            >
              SAE
            </button>{' '}
          </p>{' '}
        </div>
      )}
      {subtitle0 && <p className="contentSubtitle0">{subtitle0}</p>}
      {subtitle && !showLink && <p className="contentSubtitle">{subtitle}</p>}
      {showInfo && info && (
        <div className="contentInfo">
          <Icon name="info" size={15} />
          <span className="contentInfoText">{info}</span>
        </div>
      )}
      <button
        className="contentButton"
        data-testid="cmp-content-modal-one-button-onclick"
        type="button"
        onClick={onClickButton}
      >
        {textButton}
      </button>
    </Container>
  );
};

ContentModalOneButton.defaultProps = {
  subtitle0: '',
  subtitle: '',
  info: '',
  style: {},
  center: false,
  showLink: false
};
export default ContentModalOneButton;
